var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.languageClasses},[_c('div',{staticClass:"language-text"},[_vm._v("\n    English\n  ")]),_vm._v(" "),_c('div',{staticClass:"toggle",on:{"click":_vm.changeLanguige}},[_c('div',{staticClass:"circle"})]),_vm._v(" "),_c('div',{staticClass:"language-text"},[_vm._v("\n    Español\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-909f08d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ButtonLanguage.vue
// module id = +Wjo
// module chunks = 0